import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import base from '../../base.styl';
import styles from './Act.styl';
import Button from '../button/Button';

const Act = props => {
  let scrollTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Grid fluid className={base.container}>
      <Row center="xs">
        <Col xs={12} sm={8}>
          <h1 className={styles.headline}>Make your act count</h1>
          <p className={styles.paragraph}>
            Threats are mounting on every side: Congress is considering bills 
            that would slash funding for ESA enforcement and planning, and others 
            that would force the de-listing of species like gray wolves or 
            Pacific salmon (dodging the impartial scientific process that has 
            guided the ESAs implementation since the Act's inception). Still 
            others would interfere with the roles of NGOs and citizens in 
            enforcing the law. We cannot sit idly by and watch iconic wildlife 
            populations decline until they disappear from the Earth forever.
          </p>
        </Col>
      </Row>
      <Row center="xs">
        <Col xs={12}>
          <div onClick={scrollTop} style={{ width: '100%' }} className={styles.button_wrapper}>
            <Button title="Act Now" color="#007cf9" />
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default Act;



// WEBPACK FOOTER //
// ./src/components/static/Act.js